import React, { type FunctionComponent } from 'react'
import {
  SheetDropdown,
  ActionSheetDropdown,
  SheetDropdownDisclosureBase,
} from '@instacart/ids-core'
import { Button, Portal, ActionSheetDropdownItem } from '@retailer-platform/shared-components'
import { type RadiumStyles, SVGIcon } from 'ic-snacks'
import { css } from '@emotion/react'
import { useDomainMessages } from 'domains/products/utils/domain/intl'

interface ProductsEditProductActionSheetProps {
  showEditProduct?: boolean
  showInAssortment?: boolean
  onEditProductClick?: () => void
  onEditInAssortmentClick?: () => void
}

const dropdownButtonStyle = css({
  backgroundColor: 'transparent',
})

const editProductButtonCss: RadiumStyles = {
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'center',
  alignItems: 'center',
  margin: 'auto',
  padding: 0,
  height: 30,
  width: 38,
}

const editProductSvgCss: RadiumStyles = {
  display: 'block',
  margin: 'auto',
  paddingTop: 1,
  height: 17,
}

export const ProductsEditProductActionSheet: FunctionComponent<
  ProductsEditProductActionSheetProps
> = ({ showEditProduct, showInAssortment, onEditProductClick, onEditInAssortmentClick }) => {
  const i18n = useDomainMessages({
    editProduct: 'productsDomain.search.edit.product',
    editInAssortment: 'productsDomain.search.edit.inAssortment',
  })

  /**
   * The portal here is necessary, otherwise the `ActionSheetDropdown` is clipped by the other
   * `SheetDropdownDisclosureBase` components displayed nearby.
   */
  const dropDown = (
    <Portal>
      <ActionSheetDropdown description="Dropdown">
        {showEditProduct && (
          <ActionSheetDropdownItem onClick={onEditProductClick}>
            {i18n.editProduct}
          </ActionSheetDropdownItem>
        )}
        {showInAssortment && (
          <ActionSheetDropdownItem onClick={onEditInAssortmentClick}>
            {i18n.editInAssortment}
          </ActionSheetDropdownItem>
        )}
      </ActionSheetDropdown>
    </Portal>
  )

  return (
    <SheetDropdown>
      <SheetDropdownDisclosureBase css={dropdownButtonStyle}>
        <Button style={editProductButtonCss} variant={'secondary'}>
          <SVGIcon style={editProductSvgCss} name="moreFilled" size={'small'} />
        </Button>
      </SheetDropdownDisclosureBase>

      {dropDown}
    </SheetDropdown>
  )
}
